export const environment = {
  production: true,
  apiUrl: 'https://chvfivi.dane.gov.co:9003/'
};
